module.exports = "https://cdn.hellotech.com/client-assets/CompAccessories_bcb1b1aba8ca90f9a97a99715ee65be5.png";